import React from 'react';

// Antes las 9 promos de AMAZON_PROMOS (Prime, Prime Video, Kindle, listas de
// boda/nacimiento...) compartian el mismo icono generico (una bolsa de la
// compra) -- el usuario detecto que ninguna tenia "la imagen que le toca".
// Un icono propio y reconocible por servicio (aunque sea una linea simple,
// sin usar el logo real de Amazon por marca registrada) ayuda a que el
// usuario entienda de un vistazo que promo es antes de leer el texto.
const ICON_PATHS = {
    prime: (
        <>
            <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3Z" />
            <path d="M4.5 7.5 12 12l7.5-4.5" />
            <path d="M12 12v9" />
        </>
    ),
    'prime-extra': (
        <>
            <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3Z" />
            <path d="M4.5 7.5 12 12l7.5-4.5" />
            <path d="M12 12v9" />
        </>
    ),
    'prime-joven': (
        <>
            <path d="M12 4 2 9l10 5 10-5-10-5Z" />
            <path d="M6 11v5c0 1.5 2.5 3 6 3s6-1.5 6-3v-5" />
            <path d="M22 9v6" />
        </>
    ),
    music: (
        <>
            <path d="M9 18V5l11-2v13" />
            <circle cx="6" cy="18" r="3" />
            <circle cx="17" cy="16" r="3" />
        </>
    ),
    kindle: (
        <>
            <path d="M4 5.5C4 4.7 4.7 4 5.5 4H12v16H5.5A1.5 1.5 0 0 1 4 18.5v-13Z" />
            <path d="M20 5.5c0-.8-.7-1.5-1.5-1.5H12v16h6.5c.8 0 1.5-.7 1.5-1.5v-13Z" />
        </>
    ),
    'prime-video': (
        <>
            <rect x="3" y="5" width="18" height="13" rx="2" />
            <path d="M10.5 9.5v4l3.5-2-3.5-2Z" fill="currentColor" stroke="none" />
        </>
    ),
    'lista-nacimiento': (
        <>
            <path d="M10 3h4" />
            <path d="M10.5 3v3" />
            <path d="M13.5 3v3" />
            <path d="M8 8.5h8a1.5 1.5 0 0 1 1.5 1.5v7.5a3 3 0 0 1-3 3h-5a3 3 0 0 1-3-3V10A1.5 1.5 0 0 1 8 8.5Z" />
            <path d="M8 13h8" />
        </>
    ),
    'lista-bodas': (
        <>
            <circle cx="9" cy="14" r="5" />
            <circle cx="15" cy="14" r="5" />
        </>
    ),
    tienda: (
        <path d="M12 3.5l2.6 5.4 5.9.7-4.3 4.1 1.1 5.9-5.3-2.9-5.3 2.9 1.1-5.9-4.3-4.1 5.9-.7L12 3.5Z" />
    )
};

const AmazonPromoIcon = ({ id, size = 20 }) => (
    <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
    >
        {ICON_PATHS[id] || ICON_PATHS.tienda}
    </svg>
);

export default AmazonPromoIcon;
